import { gateway } from "../../../gateway";

export const checkEmailAvailability = async (email) => {
  try {
    const response = await gateway.get(`/users/isemailavailable/${email.toLowerCase().trim()}`);
    // Backend returns { status: 200, data: { isEmailAvailable: boolean, message: string } }
    const isAvailable = response.data?.data?.isEmailAvailable;
    return isAvailable === true; // Ensure we return an explicit boolean
  } catch (error) {
    console.error("Email check error:", error);
    // If there's an error, assume the email is not available
    return false;
  }
};
